import yaml from 'yaml.macro'

const lifeAreas = yaml('./life_areas.yml');


export default lifeAreas.life_areas;
